import React, { useState } from "react";
import "./Style.css";
import holidayBanner from "../images/g-1.avif";
import collection1 from "../images/b-1.avif";
import collection2 from "../images/e-1.avif";
import collection3 from "../images/n-1.avif";
import collection4 from "../images/r-1.avif";
import collection5 from "../images/collection5.webp";
import collection6 from "../images/collection6.webp";
import collection7 from "../images/collection7.webp";
import collection8 from "../images/collection8.webp";
import stoneImage from "../images/stoneImage.webp";
import giftImage from "../images/gift.webp";
import Craftsmanship from "../images/craftsmanship.webp";
import storyImage from "../images/storyImage.webp";
import readyToShip from "../images/w-1.avif";
import img1 from "../images/img1.jpg";
import img2 from "../images/img2.jpg";
import img3 from "../images/img3.jpg";
import img4 from "../images/img4.jpg";
import img5 from "../images/img5.jpg";
import img6 from "../images/img6.jpg";
import img7 from "../images/img7.jpg";
import img8 from "../images/img8.jpg";
import img9 from "../images/img9.jpg";
import img10 from "../images/img10.jpg";
import goldImage from "../images/w-2.avif";
import image from "../images/m-1.avif";
import image2 from "../images/v-1.avif";
import image3 from "../images/s-1.avif";
import { Link, useNavigate } from "react-router-dom";

function Index() {
  const navigate = useNavigate();

  const redirectToProductPage = (path) => {
    navigate(`/${path}`);
  };
  const collections = [
    { id: 1, title: "BRACELETS", imgSrc: collection1, path: "bracelets" },
    { id: 2, title: "EARRINGS", imgSrc: collection2, path: "earrings" },
    { id: 3, title: "NECKLACES", imgSrc: collection3, path: "necklaces" },
    { id: 4, title: "RINGS", imgSrc: collection4, path: "ring" },
  ];

  const collectionDescriptions = [
    {
      id: 1,
      title: "Workday Glow-Up",
      description:
        "Jewelry that seamlessly takes you from your morning coffee to evening meetings.",
      imgSrc: collection5,
    },
    {
      id: 2,
      title: "Dazzling Winter Nights",
      description: "Make every winter celebration golden.",
      imgSrc: collection6,
    },
    {
      id: 3,
      title: "Shine Bright All Night",
      description: "Sapphire hues that glow as beautifully as the night sky.",
      imgSrc: collection7,
    },
    {
      id: 4,
      title: "Holiday Sparkle",
      description: "Elegance for every holiday moment.",
      imgSrc: collection8,
    },
  ];

  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];

  const exhibitions = [
    {
      title: "Shades of Blue by Van Cleef & Arpels",
      date: "January 2, 2025",
      location: "20, place Vendôme in Paris",
      image: image2,
    },
    {
      title: "Shakudō: from Samurai Ornaments to Jewelry",
      date: "December 11, 2024",
      location: "L’ÉCOLE, School of Jewelry Arts in Hong Kong",
      image: image3,
    },
  ];

  const ExhibitionCard = ({ title, date, location, image }) => {
    return (
      <div className="exhibition-card">
        <img src={image} alt={title} className="exhibition-image" />
        <p className="exhibition-date">Exhibition - {date}</p>
        <h2 className="exhibition-title">{title}</h2>
        <h2 className="exhibition-title">{location}</h2>
      </div>
    );
  };

  return (
    <>
      <section className="hero-banner">
        <video className="hero-video" autoPlay loop muted>
          <source
            type="video/mp4"
            src="https://www.vancleefarpels.com/content/dam/vancleefarpels/Homepage/homepage/2025/objets-extraordinaires/ApparitionDesBais_fond-noir_16-9_V3_light.mp4"
          />
          Your browser does not support the video tag.
        </video>
      </section>

      {/* <div className="holiday-sale-banner">
        <img src={holidayBanner} />
      </div> */}

      <div className="collections-section">
        <h2 className="section-title">COLLECTIONS</h2>
        <div className="collections-grid">
          {collections.map((item) => (
            <div
              className="collection-item"
              key={item.id}
              onClick={() => redirectToProductPage(item.path)}
            >
              <img
                src={item.imgSrc}
                alt={item.title}
                className="collection-image"
              />
              <h3 className="collection-title">{item.title}</h3>
            </div>
          ))}
        </div>
        {/* <div className="descriptions-grid">
          {collectionDescriptions.map((desc) => (
            <div className="description-item" key={desc.id}>
              <img
                src={desc.imgSrc}
                alt={desc.title}
                className="description-image"
              />
              <div className="description-content">
                <h3 className="description-title">{desc.title}</h3>
                <p className="description-text">{desc.description}</p>
              </div>
            </div>
          ))}
        </div> */}
      </div>

      <div className="ready-to-ship-container">
        <div className="left-section">
          <img src={readyToShip} alt="Ready to Ship" />
        </div>

        <div className="right-section">
          <div className="index-image">
            <img src={goldImage} alt="Product" />
          </div>
          <div className="product-info">
            <h3>Lady Arpels Heures Florales watch</h3>
            {/* <div className="price">
              <span className="old-price">$62.00</span>
              <span className="new-price">$49.60</span>
            </div> */}
            {/* <button className="view-button">VIEW</button> */}
          </div>
        </div>
      </div>

      {/* <section className="stone-quality-section">
        <div className="content-wrapper">
          <div className="text-container">
            <h2 className="section-title">Gift a Golden Touch</h2>
            <p className="section-description">
              Celebrate special moments with a golden gift that shines as
              brightly as your love. Our exquisite jewelry collection offers
              timeless pieces crafted from the finest gold, perfect for any
              occasion.
            </p>
            <hr className="stone-hr" />
            <button className="stone-button"><Link to="/gifts" >shop</Link></button>
          </div>

          <div className="image-container">
            <img src={giftImage} alt="Quality Diamonds" />
          </div>
        </div>
      </section> */}

      {/* <section className="stone-quality-section">
        <div className="content-wrapper">
          <div className="image-container">
            <img src={stoneImage} alt="Quality Diamonds" />
          </div>
          <div className="text-container">
            <h2 className="section-title">Stone Quality</h2>
            <hr className="stone-hr" />
            <p className="section-description">
              When buying jewelry, it’s imperative to purchase high quality
              pieces that will last. Our family-owned business is proud to use
              only 14k & 18k solid gold and high quality diamonds.
            </p>
          </div>
        </div>
      </section> */}

      {/* <section className="stone-quality-section">
        <div className="content-wrapper">
          <div className="text-container">
            <h2 className="section-title">Our Craftsmanship</h2>
            <hr className="stone-hr" />
            <p className="section-description">
              We take pride in creating the perfect piece of jewelry. By
              crafting and manufacturing all of our pieces in house, we make
              sure every design is built with you in mind.
            </p>
          </div>

          <div className="image-container">
            <img src={Craftsmanship} alt="Quality Diamonds" />
          </div>
        </div>
      </section> */}

      <section className="metiers-section">
        <div className="metiers-overlay">
          <div className="metiers-content">
            <h2>Métiers d'art enchant the hours</h2>
            <p>
              The Maison’s signature skills come together to imbue timepieces
              with poetry and wonder.
            </p>
          </div>
        </div>
      </section>

      <h2 className="banner-heading">Enchanting gifts</h2>

      <div className="gift-banner">
        <img src={holidayBanner} />
      </div>

      <p className="banner-p">
        Thanks to the savoir-faire, creativity and excellence, Van Cleef &
        Arpels accompanies the happiest moments of life
      </p>
      <br />

      <hr />

      {/* <section className="our-story-section">
        <div
          className="story-banner"
          style={{ backgroundImage: `url(${storyImage})` }}
        >
          <div className="story-content">
            <h2 className="story-title">Our Story</h2>
            <p className="story-description">
              Jewelry is in our blood. Through the passion of family values,
              art, and the importance of hands-on processes, we manufacture our
              jewelry in-house and pride ourselves on customer relationships.
            </p>
            <button className="story-button">GET TO KNOW US</button>
          </div>
        </div>
      </section> */}

      {/* <section className="instagram-section">
        <h2 className="instagram-title">SHOP OUR INSTAGRAM</h2>
        <p className="instagram-handle">@rubiajewels</p>
        <div className="grid-container">
          {images.map((image, index) => (
            <div key={index} className="grid-item">
              <img src={image} alt={`Instagram Post ${index + 1}`} />
            </div>
          ))}
        </div>
      </section> */}

      <div className="exhibition-section">
        {exhibitions.map((exhibition, index) => (
          <ExhibitionCard key={index} {...exhibition} />
        ))}
      </div><br />

      <hr />

      <div className="multifield">
        <div className="multifield-div">
          <h2>Caring for your jewelry creations</h2>
          <p>
            Discover how to care for and preserve your jewelry creations over
            time.
          </p>
          <span>care & services</span>
        </div>
        <div className="multifield-div">
          <h2>Our jewelry services</h2>
          <p>
            Personalize, adjust or revive your jewelry creations thanks to our
            services offer.
          </p>
          <span>Jewelry Care</span>
        </div>
        <div className="multifield-div">
          <h2>Our watchmaking services</h2>
          <p>
            Ensure optimal maintenance of your watchmaking creations over the
            years.
          </p>
          <span>Watch Care</span>
        </div>
      </div><br /><br />
    </>
  );
}

export default Index;
